<app-download-button
  [process]="true"
  (processChange)="cancel($event)"
></app-download-button>
